
import collectionsData2 from "../../collectionsData";
import CollectionCard from "../../components/CollectionCard/CollectionCard";


const Collections = () => {
    return(
        <>
             
            <div className="bg-[white] dark:bg-dark-content-bg px-[5vw] md:px-10  transition-colors duration-300 ease-in-out">
                <div className="max-w-[1600px] mx-auto">
                    <div className="pb-20 pt-14">
                        <div className="w-full flex justify-between items-center text-lg md:text-xl xl:text-2xl 2xl:text-3xl dark:text-white mb-10">
                            <h1 className="secondary_heading  text-center font-bold">All Collections</h1>
                            <div className="">
                                <select className="px-3 py-2 bg-transparent text-slate-500 dark:text-gray-200 text-base lg:text-xl rounded-[10px] border-gray-500 border-[1px]">
                                    <option>Regular Collection</option>
                                </select>
                            </div>
                        </div>
                        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 2xl:grid-cols-5 gap-8">
                            {collectionsData2.map((collection, index) => {
                                return(
                                    <CollectionCard collection = {collection} />
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Collections;